module.exports = __webpack_public_path__ + "static/media/force_app_update@2x.bbd5c739.png";